import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"

import en from "./locales/en.json"
import es from "./locales/es.json"
import ptBR from "./locales/pt-BR.json"
import zhCN from "./locales/zh-CN.json"
import ja from "./locales/ja.json"
import fr from "./locales/fr.json"
import ko from "./locales/ko.json"
import am from "./locales/am.json"
import it from "./locales/it.json"

const resources = {
  en: { translation: en },
  es: { translation: es },
  "pt-BR": { translation: ptBR },
  "zh-CN": { translation: zhCN },
  ja: { translation: ja },
  fr: { translation: fr },
  ko: { translation: ko },
  am: { translation: am },
  it: { translation: it },
}

const supportedLanguages = [
  "am",
  "en",
  "es",
  "fr",
  "it",
  "ja",
  "ko",
  "pt-BR",
  "zh-CN",
]

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "es",
    supportedLngs: supportedLanguages,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lang",
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
  })

export default i18n
